<template>
  <div ref="lastArticlesHeader" class="lastArticlesContainer">
    <v-toolbar class="categoriesHeader" elevation="0"
    >
          <v-icon @click="goBack">
            mdi-chevron-left
          </v-icon>

          <v-toolbar-title class="pageTitle">
            {{ category }}
          </v-toolbar-title>

    </v-toolbar>
    <v-divider class="headerDivider"/>
    <div class="contentWrapper categoryProducts" ref="contentWrapper">
      <product-list :renderData="renderData" v-if="!isLoading"/>
      <v-container class="lastArticlesWrapper loading" v-if="isLoading">

        <v-row
            class="articleCardRow"
        >
          <v-col cols="12"
                 class="articleCardCol"
                 v-for="index in 4"
                 :key="index"
          >
            <v-card class="articleCard"
                    elevation="0"
                    v-bind:class="{cartItem: renderData.cart && !renderData.order}"
                    light
            >
              <v-list-item three-line class="skeletonWrapper__li">
                <v-skeleton-loader class="skeletonAvatar" type="avatar">

                </v-skeleton-loader>

                <v-list-item-content>
                  <v-container>
                    <v-row class="articleCard__details">
                      <v-col cols="12"
                             class="articleNameSmall"
                      >
                        <v-skeleton-loader type="text"/>
                      </v-col>
                      <div class="articleAdditionalInfoWrapper">
                        <v-col cols="12" class="pb-0 pt-2">
                          <v-skeleton-loader type="text"/>
                        </v-col>
                      </div>
                      <v-col cols="12" class="articleStatus">
                        <v-skeleton-loader type="text"/>
                      </v-col>
                      <v-col cols="12" class="pa-0 articlePriceMain">
                        <v-skeleton-loader type="text"/>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
      <div class="bottomFiller"/>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import router from '@/router';
import {mapActions, mapGetters, mapMutations, mapState} from 'vuex'

import ProductList from "@/app/productListing/productList";
export default {
  name: "categoryProduct",
  components: {ProductList},
  data:() => {
    return {
      renderData: {cart: false, category: true, products: [], name: null},
      isLoading: true,
      category: null
    }
  },

  methods: {
    ...mapActions({
      setCategoryBreadcrumbs: 'setCategoryBreadcrumbs',
      setHeaderVisibility: 'setHeaderVisibility'
    }),

    ...mapMutations({
      setIssueMore: 'setIssueMore',
      setStoredCategoryProducts: 'setStoredCategoryProducts',
      setCurrentPage: 'setCurrentPage',
      setCurrentPosition: 'setCurrentPosition',
      setCategories: 'setCategories'
    }),

    onScroll() {
      let usersHeading = this.$refs["contentWrapper"]
      if (usersHeading) {
        let inner = usersHeading.scrollHeight
        let marginTop = usersHeading.scrollTop
        if (marginTop > 3400 && inner-marginTop <=3500 && this.issueMore !== true) {
          this.setIssueMore(true)
        }
      }
    },

    goBack() {
      router.go(-1)
    },
  },

  computed: {
    ...mapGetters({
      isLogged: 'isLogged',
      getCategories: 'getCategories'
    }),

    ...mapState({
      issueMore: 'issueMore',
      currentPosition: 'currentPosition',
      categories: 'categories',
      currentPage: 'currentPage',
      storedCategoryProducts: 'storedCategoryProducts'
    })
  },

  created() {
    this.setHeaderVisibility(false)

    if(this.getCategories.length === 0) {
      axios.get('/api/getCats')
          .then((result) => {
            this.setCategories(result.data)
            this.category = this.getCategories.filter(val =>
                val.id === parseInt(this.$router.currentRoute.params.id)
            )[0]['category']
          })
    }
    else {
      this.category = this.getCategories.filter(val =>
          val.id === parseInt(this.$router.currentRoute.params.id)
      )[0]['category']
    }



    if(this.isLogged) {
      if(this.currentPosition === null) {
        this.renderData.name = router.currentRoute.params.name
        //this.setCategoryBreadcrumbs(router.currentRoute.params.name)
        let categoryNr = this.$router.currentRoute.params.id
        axios.get('/api/products/category/'+categoryNr)
            .then((result) => {
              //this.renderData.products = result.data.data
              this.setStoredCategoryProducts(result.data.data)
              this.renderData.products = result.data.data
            })
            .finally(() => this.isLoading = false)
      }

      else {
        this.renderData.products = this.storedCategoryProducts
        this.isLoading = false
      }
    }

      this.$nextTick(function () {
        this.$refs["contentWrapper"].addEventListener('scroll', this.onScroll)
        this.onScroll

        if(this.currentPosition !== null) {
          this.$refs["contentWrapper"].scrollTo(0, this.currentPosition)
        }
      })
  },

  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll)
  },

  beforeRouteLeave(to, from, next) {
    if(to.name === 'Artikeldetails') {
      this.setCurrentPosition(this.$refs["contentWrapper"].scrollTop)
    }
    next()
  },

  watch: {
    isLogged: {
      handler(role) {
        if(role) {
          this.renderData.name = router.currentRoute.params.name
          //this.setCategoryBreadcrumbs(router.currentRoute.params.name)
          let categoryNr = this.$router.currentRoute.params.id

          axios.get('/api/products/category/'+categoryNr)
              .then((result) => {
                this.renderData.products = result.data.data
              })
              .finally(() => this.isLoading = false)
        }
      }
    },

    issueMore: {
      handler(state) {
        if(state) {
          let categoryNr = this.$router.currentRoute.params.id
          this.renderData.products = this.renderData.products.flat()
          this.setCurrentPage(this.currentPage+1)
            axios.get('/api/products/category/'+categoryNr+'?page='+this.currentPage)
                .then((result) => {
                  this.setStoredCategoryProducts(result.data.data)
                  this.renderData.products.push(result.data.data)
                  this.setIssueMore(false)
                })
        }
      }
    },
    /*
    storedCategoryProducts: {
      handler(stored) {
        this.renderData.products = stored
      }
    }
    */
  }
}
</script>

<style>
  .categoriesHeader .v-toolbar__content {
    padding-left: 0px;
    padding-right: 0px;
    display: flex;

  }

  .categoriesHeader .v-icon {
    margin-right: auto;
    z-index: 1;
  }

  .categoriesHeader button::after {
    background-color: transparent!important;
  }

  .categoriesHeader .pageTitle {
    margin: auto;
    width: 100%;
    position: absolute;
  }

  .categoriesHeader {
    background-color: transparent!important;
    z-index: 0;
  }

  .headerDivider {
    background: white;
    width: 100%;
    left: 0px;
    position: absolute;
    border: 1px solid white!important;
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.15);
    z-index: 1;
  }
</style>
